import { computed, reactive, ref } from 'vue'

export const initStore = () => {

    // localStorage - show in every tab, only can use one by one variable instead of a lumpsum object
    // sessionStorage, only show in current tab
    // State
    

    const auth = reactive({
        userId: localStorage.getItem('userId'),
        sessionId: localStorage.getItem('sessionId'),
        displayName: localStorage.getItem('displayName'),
        avatar: localStorage.getItem('avatar'),
        isVerified: localStorage.getItem('userIsVerified'),
        isEntityVerified: localStorage.getItem('entityIsVerified'),
        status: localStorage.getItem('userStatus'),
        expired: localStorage.getItem('userExpired'),
        lastLogin: localStorage.getItem('userLastLogin'),
        wlId: localStorage.getItem('wlId'),
        entityId: localStorage.getItem('entityId'),
        package: localStorage.getItem('package'),
        structure: localStorage.getItem('structure'),
        currency: localStorage.getItem('currency'),
        openId: localStorage.getItem('openId'),
        role: localStorage.getItem('role')
    })

    const proj = reactive({
        id: localStorage.getItem('projectId'),
        name: localStorage.getItem('projectName')
    })

    const nav = reactive({
        page: localStorage.getItem('page'),
        totalPage: localStorage.getItem('totalPage')
    })

    const sort = reactive({
        txnSortField: localStorage.getItem('txnSortField'),
        txnSortOrder: localStorage.getItem('txnSortOrder'),
        errLogSortField: localStorage.getItem('errLogSortField'),
        errLogSortOrder: localStorage.getItem('errLogSortOrder'),
        folSortField: localStorage.getItem('folSortField'),
        folSortOrder: localStorage.getItem('folSortOrder'),
        subSortField: localStorage.getItem('subSortField'),
        subSortOrder: localStorage.getItem('subSortOrder'),
        qrSortField: localStorage.getItem('qrSortField'),
        qrSortOrder: localStorage.getItem('qrSortOrder'),
    })

    const theme = ref(localStorage.getItem('theme'))


    // Getter
    const getUserId = computed(() => auth.userId)
    /* const getUserId = computed(() => {
        console.info('store.getUserId', 'auth.userId', auth.userId, 'localStorage', localStorage.getItem('userId'))

        return auth.userId
    }) 
    const getCurrency = computed(() => {
        console.info('store.getCurrency', 'auth', typeof auth, JSON.stringify(auth))
        console.info('store.getCurrency', 'auth.currency', auth.currency,  auth['currency'])
        return auth.currency
    })
    */
    const getWlId = computed(() => auth.wlId)
    const getEntityId = computed(() => auth.entityId)
    const getCurrency = computed(() => {
        if (auth.currency === null || auth.currency === 'null' || auth.currency === '' || auth.currency === undefined || auth.currency === 'undefined') {
            return 'USD'
        } else {
            return auth.currency
        }
    })

    const getPackage = computed(() => auth.package)
    const getStructure = computed(() => auth.structure)
    const getOpenId = computed(() => auth.openId)
    const getRole = computed(() => auth.role)
    const getDisplayName = computed(() => auth.displayName)
    const getAvatar = computed(() => auth.avatar)
    const getSessionId = computed(() => auth.sessionId)
    const getUserIsVerified = computed(() => auth.isVerified)
    const getEntityIsVerified = computed(() => auth.isEntityVerified)
    const getUserStatus = computed(() => auth.status)
    const getUserExpired = computed(() => auth.expired)
    const getUserLastLogin = computed(() => auth.lastLogin)
    const getProjectId = computed(() => proj.id)
    const getProjectName = computed(() => proj.name)
    const getPage = computed(() => nav.page)
    const getTotalPage = computed(() => nav.totalPage)

    const getTheme = computed(() => theme.value)

    const getTxnSortField = computed(() => sort.txnSortField)
    const getTxnSortOrder = computed(() => sort.txnSortOrder)
    const getErrLogSortField = computed(() => sort.errLogSortField)
    const getErrLogSortOrder = computed(() => sort.errLogSortOrder)
    const getFolSortField = computed(() => sort.folSortField)
    const getFolSortOrder = computed(() => sort.folSortOrder)
    const getSubSortField = computed(() => sort.subSortField)
    const getSubSortOrder = computed(() => sort.subSortOrder)
    const getQrSortField = computed(() => sort.qrSortField)
    const getQrSortOrder = computed(() => sort.qrSortOrder)



    // Action
    const updUserId = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            // localStorage.removeItem('userId')
            localStorage.removeItem('userId')
        } else {

            auth.userId = newValue
            // localStorage.setItem('userId', newValue)
            localStorage.setItem('userId', newValue)
        }
    }

    const updWlId = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('wlId')
        } else {

            auth.wlId = newValue
            localStorage.setItem('wlId', newValue)
        }
    }

    const updEntityId = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            // localStorage.removeItem('entityId')
            localStorage.removeItem('entityId')
        } else {

            auth.entityId = newValue
            localStorage.setItem('entityId', newValue)
        }
    }

    const updCurrency = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('currency')
        } else {

            auth.currency = newValue
            localStorage.setItem('currency', newValue)
        }
    }

    const updPackage = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('package')
        } else {

            auth.package = newValue
            localStorage.setItem('package', newValue)
        }
    }

    const updOpenId = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('openId')
        } else {

            auth.openId = newValue
            localStorage.setItem('openId', newValue)
        }
    }

    const updStructure = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('structure')
        } else {

            auth.structure = newValue
            localStorage.setItem('structure', newValue)
        }
    }

    const updSessionId = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('sessionId')
        } else {

            auth.sessionId = newValue
            localStorage.setItem('sessionId', newValue)
        }
    }

    const updDisplayName = (newValue='') => {
        auth.displayName = newValue
        localStorage.setItem('displayName', newValue)
    }

    const updAvatar = (newValue='') => {
        auth.avatar = newValue
        localStorage.setItem('avatar', newValue)
    }

    const updUserIsVerified = (newValue='') => {
        auth.isVerified = newValue
        localStorage.setItem('userIsVerified', newValue)
    }

    const updEntityIsVerified = (newValue='') => {
        auth.isEntityVerified = newValue
        localStorage.setItem('entityIsVerified', newValue)
    }

    const updUserStatus = (newValue='') => {
        auth.status = newValue
        localStorage.setItem('userStatus', newValue)
    }

    const updUserExpired = (newValue='') => {
        auth.expired = newValue
        localStorage.setItem('userExpired', newValue)
    }

    const updUserLastLogin = (newValue='') => {
        auth.lastLogin = newValue
        localStorage.setItem('userLastLogin', newValue)
    }

    const updProjectId = (newValue='') => {
        proj.id = newValue
        localStorage.setItem('projectId', newValue)
    }

    const updProjectName = (newValue='') => {
        proj.name = newValue
        localStorage.setItem('projectName', newValue)
    }

    const updTotalPage = (newValue='') => {
        nav.totalPage = newValue
        localStorage.setItem('totalPage', newValue)
    }

    const updTheme = (newValue='') => {
        theme.value = newValue
        localStorage.setItem('theme', newValue)
    }

    const updTxnSortField = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('txnSortField')
        } else {

            sort.txnSortField = newValue
            localStorage.setItem('txnSortField', newValue)
        }
    }
    const updTxnSortOrder = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('txnSortOrder')
        } else {

            sort.txnSortOrder = newValue
            localStorage.setItem('txnSortOrder', newValue)
        }
    }

    const updQrSortField = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('qrSortField')
        } else {

            sort.qrSortField = newValue
            localStorage.setItem('qrSortField', newValue)
        }
    }
    const updQrSortOrder = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('qrSortOrder')
        } else {

            sort.qrSortOrder = newValue
            localStorage.setItem('qrSortOrder', newValue)
        }
    }


    const updErrLogSortField = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('errLogSortField')
        } else {

            sort.errLogSortField = newValue
            localStorage.setItem('errLogSortField', newValue)
        }
    }

    const updErrLogSortOrder = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('errLogSortOrder')
        } else {

            sort.errLogSortOrder = newValue
            localStorage.setItem('errLogSortOrder', newValue)
        }
    }

    const updFolSortField = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('folSortField')
        } else {

            sort.folSortField = newValue
            localStorage.setItem('folSortField', newValue)
        }
    }
    const updFolSortOrder = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('folSortOrder')
        } else {

            sort.folSortOrder = newValue
            localStorage.setItem('folSortOrder', newValue)
        }
    }

    const updSubSortField = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('subSortField')
        } else {

            sort.subSortField = newValue
            localStorage.setItem('subSortField', newValue)
        }
    }
    const updSubSortOrder = (newValue='') => {
        if (newValue === null || newValue === 'null' || newValue === '' || newValue === undefined || newValue === 'undefined') {

            localStorage.removeItem('subSortOrder')
        } else {

            sort.subSortOrder = newValue
            localStorage.setItem('subSortOrder', newValue)
        }
    }

    /* provide('getUserId', getUserId)
    provide('getWlId', getWlId)
    provide('getEntityId', getEntityId)
    provide('getPackage', getPackage)
    provide('getStructure', getStructure)
    provide('getOpenId', getOpenId)
    provide('getRole', getRole)
    provide('getDisplayName', getDisplayName)
    provide('getAvatar', getAvatar)
    provide('getSessionId', getSessionId)
    provide('getUserIsVerified', getUserIsVerified)
    provide('getUserStatus', getUserStatus)
    provide('getUserExpired', getUserExpired)
    provide('getUserLastLogin', getUserLastLogin)
    provide('getProjectId', getProjectId)
    provide('getProjectName', getProjectName)
    provide('getPage', getPage)
    provide('getTotalPage', getTotalPage)
    provide('getTheme', getTheme)

    provide('updUserId', updUserId)
    provide('updWlId', updWlId)
    provide('updEntityId', updEntityId)
    provide('updPackage', updPackage)
    provide('updStructure', updStructure)
    provide('updOpenId', updOpenId)
    provide('updSessionId', updSessionId)
    provide('updDisplayName', updDisplayName)
    provide('updAvatar', updAvatar)
    provide('updUserIsVerified', updUserIsVerified)
    provide('updUserStatus', updUserStatus)
    provide('updUserExpired', updUserExpired)
    provide('updUserLastLogin', updUserLastLogin)
    provide('updProjectId', updProjectId)
    provide('updProjectName', updProjectName)
    provide('updTotalPage', updTotalPage)
    provide('updTheme', updTheme) */

    return { 
        getUserId, getWlId, getEntityId, getCurrency, getPackage, getStructure, getOpenId, getRole, getDisplayName, getAvatar, getSessionId, getUserIsVerified, getEntityIsVerified ,getUserStatus, getUserExpired, getUserLastLogin, 
        getProjectId, getProjectName, getPage, getTotalPage, getTheme, getTxnSortField, getTxnSortOrder, getQrSortField, getQrSortOrder, getErrLogSortField, getErrLogSortOrder, getFolSortField, getFolSortOrder, getSubSortField, getSubSortOrder,
        updUserId, updWlId, updEntityId, updCurrency, updPackage, updStructure, updOpenId, updSessionId, updDisplayName, updAvatar, updUserIsVerified, updEntityIsVerified, updUserStatus, updUserExpired, updUserLastLogin, 
        updProjectId, updProjectName, updTotalPage, updTheme, updTxnSortField, updTxnSortOrder, updQrSortField, updQrSortOrder,  updErrLogSortField, updErrLogSortOrder, updFolSortField, updFolSortOrder, updSubSortField, updSubSortOrder
    }
}

// added for ts
export type StoreType = ReturnType<typeof initStore>

/* 
export const useStore = () => ({
    getUserId: inject('getUserId'),
    getWlId: inject('getWlId'),
    getEntityId: inject('getEntityId'),
    getPackage: inject('getPackage'),
    getStructure: inject('getStructure'),
    getOpenId: inject('getOpenId'),
    getRole: inject('getRole'),
    getDisplayName: inject('getDisplayName'),
    getAvatar: inject('getAvatar'),
    getSessionId: inject('getSessionId'),
    getUserIsVerified: inject('getUserIsVerified'),
    getUserStatus: inject('getUserStatus'),
    getUserExpired: inject('getUserExpired'),
    getUserLastLogin: inject('getUserLastLogin'),
    getProjectId: inject('getProjectId'),
    getProjectName: inject('getProjectName'),
    getPage: inject('getPage'),
    getTotalPage: inject('getTotalPage'),
    getTheme: inject('getTheme'),
    updUserId: inject('updUserId'),
    updWlId: inject('updWlId'),
    updEntityId: inject('updEntityId'),
    updPackage: inject('updPackage'),
    updStructure: inject('updStructure'),
    updOpenId: inject('updOpenId'),
    updSessionId: inject('updSessionId'),
    updDisplayName: inject('updDisplayName'),
    updAvatar: inject('updAvatar'),
    updUserIsVerified: inject('updUserIsVerified'),
    updUserStatus: inject('updUserStatus'),
    updUserExpired: inject('updUserExpired'),
    updUserLastLogin: inject('updUserLastLogin'),
    updProjectId: inject('updProjectId'),
    updProjectName: inject('updProjectName'),
    updTotalPage: inject('updTotalPage'),
    updTheme: inject('updTheme')
})
 */